'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC, useState } from 'react'
import Carousel from 'react-multi-carousel'

import Images from '@/components/EtsMap/Images'
import MobileMapLegendBox, { mobileCards } from '@/components/EtsMap/MobileMapLegendBox'
import FullScreenOnMobileWrapper from '@/components/FullScreenOnMobileWrapper'

import 'react-multi-carousel/lib/styles.css'

const MobileCarouselMap: FC = () => {
    const { xsScreen } = useDevice()
    const [activeSlider, setActiveSlider] = useState<number>(0)

    return (
        <FullScreenOnMobileWrapper
            sx={{
                height: '720px',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                backgroundColor: `Grey300`,
                position: 'relative',
                '.react-multi-carousel-track  ': {
                    marginLeft: xsScreen ? '40px' : '150px',
                    justifyContent: 'stretch',
                    alignItems: 'stretch',
                },
            }}
        >
            <Images
                activeImageNumber={activeSlider + 1 > 3 ? '1' : (activeSlider + 1).toString()}
                isMobile={true}
            />
            <Box sx={{ width: '100%', mb: 6 }}>
                <Carousel
                    infinite={true}
                    partialVisible={true}
                    showDots={false}
                    arrows={false}
                    slidesToSlide={1}
                    swipeable
                    rewind={false}
                    afterChange={(newActive) => setActiveSlider(newActive - 1)}
                    ssr={true}
                    responsive={{
                        all: {
                            breakpoint: {
                                max: 10000,
                                min: 0,
                            },
                            items: 1,
                            partialVisibilityGutter: xsScreen ? 80 : 300,
                        },
                    }}
                >
                    {mobileCards.map((card, index) => (
                        <Box
                            key={index}
                            sx={{
                                pl: 1,
                                pr: 1,
                                height: '100%',
                            }}
                        >
                            <MobileMapLegendBox {...card} />
                        </Box>
                    ))}
                </Carousel>
            </Box>
        </FullScreenOnMobileWrapper>
    )
}

export default MobileCarouselMap
